import * as TYPES from './types'

/**
 * ========================================
 *                  global event
 * ========================================
 */
export const listenScroll = ({commit}) => {
  window.addEventListener('scroll', function () {
    const scrollTop = document.body.scrollTop
      || window.pageYOffset
      || document.documentElement.scrollTop
    commit(TYPES.DOC_SCROLL_V, scrollTop || 0)
  })
}
